import { motion } from "framer-motion";
import { useState, useEffect } from "react";

export default function AnimatedBox({ children, className, style }) {
  const [viewportAmount, setViewportAmount] = useState(0.2);

  useEffect(() => {
    function handleResize() {
      if (window.innerWidth >= 1024) {
        setViewportAmount(1);
      } else {
        setViewportAmount(0.2);
      }
    }

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <motion.div
      className={className}
      style={style}
      initial={{ opacity: 0, scale: 0.8, y: 50, z: -200 }}
      whileInView={{ opacity: 1, scale: 1, y: 0, z: 0 }}
      transition={{ duration: 0.9, ease: "easeOut" }}
      viewport={{ once: true, amount: viewportAmount }}
    >
      {children}
    </motion.div>
  );
}
